export const readingTime = (wordCount: number, wordsPerMin: number) => {
    if (wordCount <= wordsPerMin) {
        return "Unter 1 Minute Lesedauer";
    } else {
        return Math.ceil(wordCount / wordsPerMin) + " Minuten Lesedauer";
    }
}

export const readingTimeFromContent = (content: string, wordsPerMin?: number) => readingTime(content.trim().replace('/\s+/gi', ' ').split(' ').length, wordsPerMin ?? 200);